//console.log("Hello world!");

//var myDiv2 = document.querySelector(".header.header--left");
//console.log(myDiv2);
//myDiv2.setAttribute("style", "background-color:transparent;");



$(window).scroll(function() {
  scroll = $(window).scrollTop();
  if (scroll >= 80) {
    $('.site-header').css('top', '0');
    $('.header.header--left').css('background-color', 'white');
    $('.header-menu__link').css('color', 'black');
  } else {
    $('.site-header').css('top', 'initial');
    $('.header.header--left').css('background-color', 'transparent');
    $('.header-menu__link').css('color', 'white');
  }
});